import React, {useState} from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import './pcburn.css';
//import GitHubButton from "react-github-btn";

const ProjectCard = ({   project: { title, description, tags, link, mlink,logo } }) => {
  const[isShow, anime] =   useState(false);
  return (
    <div className="  lg:w-full  h-full bg-[#728f72]	dark:bg-[#071407]	 p-4  w-2/3    m-3 mx-auto   rounded-xl border-2 border-gray-300">
      <div class=" grid   grid-cols-2 justify-between"> 
      <a href={link}>
        <h1 className=" justify-start justify-items-start text-xl font-bold">
          {title}{" "}
          <FaExternalLinkAlt className="inline  w-3 h-3 align-baseline" />
        </h1>
      </a>
      <div className="my-1 gap-1  h-2	justify-end      text-xs flex shrink   flex-wrap text-justify     md:gap-2">
        {tags.map((tag) => (
          <div className="px-1 py-1  rounded-full   border-2  ">{tag}</div>
        ))}
         <>
      { logo ? <a className=" px-1 py-1  text-2xl   rounded-full   border-2 " href={mlink}>
        {logo}
      </a> :  <h1> </h1> }
    </>
        
      </div> 
      </div>
 
      <hr className="my-2 md:my-3" />
       <div onClick= {()=> anime(!isShow)} > 
          {isShow&&  <p className=" text-white    text-xs  hover:opacity-100 h-12 lg:text-sm text-justify ">{description}</p>   }   
          {!isShow&& <div class="flex items-center justify-center space-x-2 hover:opacity-0 ">
          <div className="w-2 h-2 rounded-full animate-pulse bg-white"></div>
          <div className="w-2 h-2 rounded-full animate-pulse bg-white"></div>
          <div className="w-2 h-2 rounded-full animate-pulse bg-white"></div> 
</div>  }  
      </div>
      
    </div>
  );
};

export default ProjectCard;
 